import React from "react";
import Select, { components } from "react-select";

const SingleSelectEclinPro = ({
  options,
  selectedOption,
  setSelectedOption,
  onChange,
  setEnableSave,
  setIsDelink,
  eclinProTrialsDetailsID,
}) => {
  // Format options
  const formattedOptions = options?.map((opt) => ({
    value: opt.eclinProTrialsDetailsID,
    label: opt.displayName,
    ...opt,
  }));

  const handleChange = (selected) => {
    // setEnableSave(true);
    setSelectedOption(selected);
    onChange && onChange(selected);
  };

  // Custom dropdown arrow
  const DropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
      <span className="pointer-events-none">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path
            d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
            stroke="#245CEA"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </components.DropdownIndicator>
  );

  // Custom Clear Indicator
  const ClearIndicator = (props) => {
    const { clearValue } = props;

    const handleClear = (e) => {
      e.preventDefault();
      e.stopPropagation();
console.log('selectedOption.eclinProTrialsDetailsID', selectedOption.eclinProTrialsDetailsID)
console.log('selectedOption.eclinProTrialsDetailsID eclinProTrialsDetailsID', eclinProTrialsDetailsID)
      if (
        selectedOption &&
        selectedOption.eclinProTrialsDetailsID === eclinProTrialsDetailsID
      ) {
        setIsDelink(selectedOption);
      } else {
        clearValue();
      }
    };

    return (
      <components.ClearIndicator {...props}>
        <span
          onMouseDown={handleClear} // IMPORTANT
          className="cursor-pointer text-gray-500 hover:text-red-500"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#555"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </span>
      </components.ClearIndicator>
    );
  };

  const customComponents = {
    DropdownIndicator,
    ClearIndicator,
    IndicatorSeparator: () => null,
  };

  const customStyles = {
    singleValue: (provided) => ({ ...provided, fontSize: "16px" }),
    option: (provided) => ({ ...provided, fontSize: "16px" }),
    clearIndicator: (provided) => ({ ...provided, padding: "4px" }),
  };

  return (
    <div
      className="border border_color rounded-lg p-1 w-[730px]"
      style={{ minHeight: "3rem" }}
    >
      <Select
        options={formattedOptions}
        value={selectedOption}
        onChange={handleChange}
        components={customComponents}
        placeholder="Select Trial"
        styles={customStyles}
        className="text-base"
        closeMenuOnSelect={true}
        isClearable={true}
        setSelectedOption={setSelectedOption} // <-- required
      />
    </div>
  );
};

export default SingleSelectEclinPro;
